import React from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { gql } from '@apollo/client';
import Breadcrumb from '../components/Breadcrumb';
import M3Card from '../components/M3Card';
import M3LinearProgress from '../components/M3Progress';
import { UPDATE_USER } from '../graphql/mutations';
import { USERS_QUERY } from '../graphql/queries';

const USER_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      name
      email
      role
      disabled
      createdAt
    }
  }
`;

const ROLE_OPTIONS = [
  { value: '0', label: 'User' },
  { value: '1', label: 'Admin' }
];

export default function UserShowPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, loading, error } = useQuery(USER_QUERY, { variables: { id } });

  const [updateUser] = useMutation(UPDATE_USER, {
    refetchQueries: [{ query: USERS_QUERY }]
  });

  if (error)
    return (
      <div className="page-content">
        <p className="alert alert-danger">Error: {error.message}</p>
      </div>
    );

  if (loading)
    return (
      <div className="page-content">
        <M3LinearProgress indeterminate />
      </div>
    );

  const user = data?.user;
  if (!user) return <div className="page-content">User not found.</div>;

  return (
    <div className="page-content detail-page">
      <Breadcrumb items={[{ label: 'Users', link: '/users' }, { label: user.name }]} />

      <div className="detail-header">
        <h1>{user.name}</h1>
        <div className="detail-actions">
          <Link to={`/users/${id}/edit`} className="btn btn-secondary">
            <span className="material-symbols-rounded md-18">edit</span>
            Edit
          </Link>
        </div>
      </div>

      <M3Card variant="outlined">
        <M3Card.Header title="Account" />
        <M3Card.Body>
          <div className="detail-row">
            <span className="detail-label">Email</span>
            <span className="detail-value">{user.email}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Role</span>
            <span className="detail-value">{user.role === 'admin' ? 'Admin' : 'User'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Disabled</span>
            <span className="detail-value">{user.disabled ? 'Yes' : 'No'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Created</span>
            <span className="detail-value">{new Date(user.createdAt).toLocaleDateString()}</span>
          </div>
        </M3Card.Body>
      </M3Card>
    </div>
  );
}
